<a *ngIf=word
   class="item-box pointer"
   id="{{ listItemId(word.id) }}">

  <div class="item-head-box">

    <app-word-disp [word]="word"
                   [showLevel]="showLevel"
                   [wrapHanja]="true"></app-word-disp>
    <div class="item-option-box">
      <app-word-play-btn [word]="word"></app-word-play-btn>

      <app-word-record-btn [word]="word"></app-word-record-btn>
    </div>

  </div>

  <div class="item-body-box">

    <div class="des-list-box">
      <div class="des-box">
        <div class="label-box">
          <div class="label-txt"
               *ngFor="let poomsa of word.partOfSpeech">{{ GetPoomsaTxt(poomsa) }}</div>
        </div>
        <div class="con-box">

          <!-- 기본 뜻이 있는 경우 -->
          <div class="meaning-box"
               *ngIf="getDefaultMeaning(word)">
            <div class="meaning-title"><div class="border-box">뜻</div></div>
            <div class="txt-box"
                 [innerHTML]="getDefaultMeaning(word) | resize | keepHtml"></div>
          </div>

          <!-- 뜻이 여러개인 경우 -->
          <div class="meaning-box"
               *ngFor="let meaning of getNumberedMeanings(word); let idx = index">
            <div class="meaning-title">
              <div class="border-box">{{ (!getDefaultMeaning(word) && idx === 0) ? "뜻" : "" }}</div>
            </div>
            <div class="txt-box flex">
              <div class="txt-box-num">{{ (idx + 1).toString() + '.' }}</div>
              <div class="txt-box-meaning"
                   [innerHTML]="meaning | resize | keepHtml"></div>
            </div>
          </div>
          <div class="meaning-box"
               *ngIf="getMoreMeanings(word) > 0">
            <div class="txt-box more"><{{ getMoreMeanings(word) }}개의 뜻이 더 있습니다.></div>
          </div>
        </div>
      </div>

    </div>

  </div>





</a>
